import React, {useState} from "react";
import "./SelectorPopup.scss";
import Popup from "../Popup/Popup";


const SelectorPopup = (props) => {
  const [selected, setSelected] = useState(props.default ? props.default : false);

  const optionsHtml = props.options.map(option => {
    return <div className={'selector-popup-item' + (option.id === selected ? " selected" : "")} onClick={() => setSelected(option.id)}>
      <div className={'title'}>{option.title}</div>
      <div className={'text'}>{option.text}</div>
    </div>
  });
  return (
    <Popup
      title={props.title}
      confirmButton={props.confirmButton}
      cancelButton={props.cancelButton}
      onConfirm={() => props.onConfirm(selected)}
      onCancel={props.onCancel}
      style={{width:700}}
      disableConfirm={!selected}
    ><ul className={'selector-popup'}>
      {optionsHtml}
    </ul></Popup>

  );
}

export default SelectorPopup;